import React, { useEffect, useRef, useState } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import ShadowCard from "../../../components/common/ShadowCard";
import {
  clearRelationshipManagerReportDetails,
  clearRelationshipManagerReportList,
  setRelationshipManagerDetail,
} from "../reportsSlice";
import AlertBox from "../../../components/common/AlertBox";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Button } from "@progress/kendo-react-buttons";
import { RxCross2 } from "react-icons/rx";
import FormCheckboxGroup from "../../../components/formFields/FormCheckboxGroup";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { BsThreeDotsVertical } from "react-icons/bs";
import { findRMWiseReport } from "../services/reports.services";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { IMnageUser } from "../../clientForm/clientformModel";
import { getAllUser } from "../../clientForm/services/services.clientform";
// import { requiredValidator } from "../../../components/formFields/CommonValidator";
import { IoPrint } from "react-icons/io5";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import { EDIT_ACCESS } from "../../../_contstants/common";
import { checkAcessRights } from "../../../_helper/helper";
import { useNavigate } from "react-router-dom";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const DummyChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const createdBy = localStorage.getItem("UserID");
  useEffect(() => {
    formRenderProps.onChange("UserID", {
      value: createdBy,
    });
  }, []);

  return null;
};

const RelationshipManagerReport: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);
  const RelationshipManagerReportList = useAppSelector(
    (state) => state.reports.RelationshipManagerReportList
  );
  const UserList = useAppSelector((state) => state?.client?.UserList);
  const RelationshipManagerReportDetails = useAppSelector(
    (state) => state.reports.RelationshipManagerReportDetails
  );
  const [initialValue, setInitialValue] = useState<any>({});
  const [formKey, setFormKey] = useState<any>(1);
  const isEditRef = React.useRef(false);

  useEffect(() => {
    dispatch(getAllUser());
    return () => {
      if (!isEditRef.current) {
        dispatch(clearRelationshipManagerReportList());
        dispatch(clearRelationshipManagerReportDetails());
      }
    };
  }, []);

  useEffect(() => {
    setInitialValue({
      ...RelationshipManagerReportDetails,
    });
    setFormKey(formKey + 1);
  }, [RelationshipManagerReportDetails]);

  const handleSubmit = (values: any) => {
    const payload = {
      RelationManagerID: values?.RelationManagerID,
    };
    const setPayload = {
      ...payload,
    };
    dispatch(setRelationshipManagerDetail(setPayload));
    dispatch(findRMWiseReport(payload));
  };

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            key={formKey}
            initialValues={initialValue}
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Relationship Manager Report
                    </Typography.h4>
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      name="RelationManagerID"
                      label="Relationship Manager"
                      placeholder="Select Relationship Mananger"
                      component={FormSelectionField}
                      options={UserList?.map((user: IMnageUser) => {
                        return {
                          value: user?.ID,
                          label: `${user?.FirstName} ${user?.LastName}`,
                        };
                      })}
                      //   validator={requiredValidator}
                      //   astrike={true}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem style={{ position: "relative" }}>
                    <div style={{ position: "absolute", top: "34px" }}>
                      <ButtonWithLoading
                        label={"View"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </div>
                  </GridLayoutItem>
                </GridLayout>
                <DummyChangeWatcher formRenderProps={formRenderProps} />
              </FormElement>
            )}
          />
        </ShadowCard>

        {RelationshipManagerReportList &&
          RelationshipManagerReportList.length > 0 && (
            <ShadowCard style={{ marginTop: 10 }}>
              <RelationshipManagerReportGridCommponent isEditRef={isEditRef} />
            </ShadowCard>
          )}
      </GridLayoutItem>
    </GridLayout>
  );
};

const columns = [
  { label: "Client Name", value: "Name" },
  { label: "Mobile No", value: "MobileNo" },
  { label: "Email ID", value: "EmailID" },
  { label: "Lead Owner", value: "LeadOwnerName" },
  { label: "Company", value: "CompanyName" },
  { label: "Title", value: "Title" },
  { label: "Phone No", value: "PhoneNo" },
  { label: "Website", value: "Website" },
  { label: "Reference ", value: "RefName" },
  { label: "Reference Mobile No", value: "RefMobileNo" },
  { label: "Industry", value: "Industry" },
  { label: "No of Employee", value: "NoofEmp" },
  { label: "Annual Revenue", value: "AnnualRevenue" },
  { label: "City", value: "CityName" },
  { label: "Country ", value: "CountryName" },
  { label: "State ", value: "StateName" },
  { label: "Address", value: "Address" },
  { label: "Occupation ", value: "OccupationName" },
  { label: "Birth Date", value: "BirthDate" },
  { label: "Marriage Date", value: "MarriageDate" },
  { label: "Pincode", value: "PinCode" },
  { label: "Notes", value: "Notes" },
  { label: "Group Code", value: "GroupCode" },
  { label: "Lead Stage", value: "LeadStage" },
  { label: "Relation Manager", value: "RelationManagerName" },
  { label: "Business Type", value: "BusinessType" },
];

const RelationshipManagerReportGridCommponent: React.FC<{
  isEditRef: React.MutableRefObject<boolean>;
}> = ({ isEditRef }) => {
  const gridRef = React.useRef<any>(null);

  const loading = useAppSelector((state) => state.reports.loading);
  const RelationshipManagerReportList = useAppSelector(
    (state) => state.reports.RelationshipManagerReportList
  );
  const RelationshipManagerReportDetails = useAppSelector(
    (state) => state.reports.RelationshipManagerReportDetails
  );
  const tableRef = useRef<any>(null);

  const isEditAccessLeads = checkAcessRights("/clientform", EDIT_ACCESS);
  const [showfilterColumns, setShowFilterColumns] = React.useState(false);
  const [selectedGroup, setSelectedGroup] = React.useState<string | null>(null);
  const navigate = useNavigate();
  const handleRowClick = (ID: string) => {
    const groupKey = `${ID}`;
    setSelectedGroup(selectedGroup === groupKey ? null : groupKey);
  };

  const initialValues = {
    filter_columns: [
      "Name",
      "MobileNo",
      "EmailID",
      "LeadOwnerName",
      "CompanyName",
      "Title",
      "PhoneNo",
      "Website",
      "RefName",
      "RefMobileNo",
      "Industry",
      "NoofEmp",
      "AnnualRevenue",
      "CityName",
      "CountryName",
      "StateName",
      "Address",
      "OccupationName",
      "BirthDate",
      "MarriageDate",
      "PinCode",
      "Notes",
      "GroupCode",
      "LeadStage",
      "RelationManagerName",
      "BusinessType",
    ],
  };

  const printTable = () => {
    let printbuttons = document.querySelector(
      ".printbuttons"
    ) as HTMLElement | null;
    let report_container = document.querySelector(
      ".report-container"
    ) as HTMLElement | null;

    if (printbuttons) printbuttons.style.display = "none";
    if (report_container) report_container.style.padding = "20px 0";
    let printWindow = window.open("", "_blank");
    if (!printWindow) {
      console.error("Failed to open print preview window.");
      return;
    }
    printWindow.document.write(`
        <html>
        <head>
          <title>Print Preview</title>
          <style>
            @page { margin: 1cm; }
            .print-page { page-break-after: always; }
            body { font-family: Arial, sans-serif; }
            .report-view-table {
                outline:none;
                border:1px solid black;
                border-collapse:collapse;
            }
                .report-view-table thead tr {
                position:unset ;
                background:lightgrey;
                }
             .report-view-table thead tr th , .report-view-table tbody tr td {
             border:1px solid black;
             }
          </style>
        </head>
        <body>
        <h2 style="text-align:center;">Relationship Manager Report</h2>
        <h4 style="text-align:center; margin-top:0; color:grey;">${RelationshipManagerReportList?.[0]?.RelationManagerName}</h4>
          ${tableRef.current.outerHTML}
          <script>
            window.onload = function() {
              window.print();
            };
          </script>
        </body>
        </html>
      `);
    printWindow.document.close();

    if (printbuttons) printbuttons.style.display = "block";
    if (report_container) report_container.style.padding = "20px 10px";
  };

  const handleExportExcel = () => {
    /*===*===* YOUR TABLE *===*===*/
    const table = document.querySelector(
      ".report-view-table"
    ) as HTMLTableElement;
    if (!table) return;
    const workbook = new ExcelJS.Workbook();
    /*===*===* YOUR SHEET NAME *===*===*/
    const worksheet = workbook.addWorksheet(
      `${RelationshipManagerReportList?.[0]?.RelationManagerName}`
    );
    const rows = Array.from(table.querySelectorAll("tr"));
    let excelRowIndex = 1; // Excel row index (1-based)
    const occupiedCells: Record<string, boolean> = {}; // Track occupied cells
    const colWidths: number[] = [];

    rows.forEach((row, rowIndex) => {
      const cells = Array.from(row.children) as HTMLTableCellElement[];
      let colIndex = 1; // Reset to first column for each row

      cells.forEach((cell) => {
        const cellContent = cell.textContent?.trim() || "";
        const cellLength = cellContent.length;
        const colSpan = cell.colSpan || 1;
        const rowSpan = cell.rowSpan || 1;

        colWidths[colIndex] = Math.max(
          colWidths[colIndex] || 10,
          cellLength + 2
        );
        /*===*===* Find the next available column (skip occupied columns) *===*===*/
        while (occupiedCells[`${excelRowIndex}-${colIndex}`]) {
          colIndex++;
        }
        /*===*===* SET VALUE AND TABLE STYLE *===*===*/
        const excelCell = worksheet.getRow(excelRowIndex).getCell(colIndex);
        const numericValue = Number(cellContent.replace(/,/g, ""));
        if (
          !isNaN(numericValue) &&
          cellContent.replace(/,/g, "").match(/^\d+(\.\d+)?$/)
        ) {
          excelCell.value = numericValue; // Store as a real number
        } else {
          excelCell.value = cellContent; // Store as text
        }
        // excelCell.value = cellContent;
        excelCell.alignment = { horizontal: "left", vertical: "middle" };
        excelCell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };

        /*===*===* HEADER STYLE *===*===*/
        if (rowIndex === 0) {
          excelCell.font = { bold: true };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "6cb27a" },
          };
        }
        // /*===*===* LAST ROW STYLE *===*===*/
        // if (rowIndex === rows.length - 1) {
        //   excelCell.font = { bold: true };
        //   excelCell.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "D9E1F2" },
        //   };
        // }
        /*===*===* HANDEL colSpan AND rowSpan *===*===*/
        if (colSpan > 1 || rowSpan > 1) {
          const startCell = worksheet
            .getRow(excelRowIndex)
            .getCell(colIndex).address;
          const endCell = worksheet
            .getRow(excelRowIndex + rowSpan - 1)
            .getCell(colIndex + colSpan - 1).address;
          worksheet.mergeCells(`${startCell}:${endCell}`);
          // Mark merged cells as occupied
          for (let r = 0; r < rowSpan; r++) {
            for (let c = 0; c < colSpan; c++) {
              occupiedCells[`${excelRowIndex + r}-${colIndex + c}`] = true;
            }
          }
        }
        colIndex += colSpan;
      });

      excelRowIndex++; // Move to next row
    });

    worksheet.columns = colWidths.map((width) => ({ width }));
    /*===*===* SAVE THE FILE  *===*===*/
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        blob,
        `Relationship Manager Report-
        ${moment().format("DD-MM-YYYY_hh-mm-A")}.xlsx`
      );
    });
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {RelationshipManagerReportList && RelationshipManagerReportList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            const checkInclude = (key: string) => {
              return formRenderProps
                .valueGetter("filter_columns")
                ?.includes(key);
            };
            return (
              <FormElement
                style={{ width: "100%", minHeight: "calc(100vh - 290px)" }}
              >
                <GridLayout
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <Typography.h4 className="m-0">
                      Relationship Manager Report List
                    </Typography.h4>
                    <div className="position-relative d-flex">
                      <Button
                        style={{ marginRight: 5 }}
                        type="button"
                        fillMode={"solid"}
                        themeColor={"info"}
                        onClick={printTable}
                      >
                        <IoPrint style={{ fontSize: "18px" }} /> PRINT
                      </Button>
                      <Button
                        style={{ marginRight: 5 }}
                        type="button"
                        fillMode={"solid"}
                        themeColor={"primary"}
                        onClick={handleExportExcel}
                      >
                        <PiMicrosoftExcelLogoFill
                          style={{ fontSize: "18px" }}
                        />{" "}
                        EXPORT
                      </Button>
                      {/* <Button
                        type="button"
                        fillMode={"solid"}
                        themeColor={"primary"}
                        onClick={handleExportExcel}
                        style={{ marginRight: 5 }}
                      >
                        Excel Export
                      </Button> */}
                      {/* )} */}
                      <Tooltip
                        anchorElement="target"
                        position="left"
                        parentTitle={true}
                      >
                        <Button
                          title="Filter Columns"
                          type="button"
                          themeColor={"tertiary"}
                          fillMode={"solid"}
                          onClick={() => setShowFilterColumns(true)}
                        >
                          FILTER
                          <BsThreeDotsVertical />
                        </Button>
                      </Tooltip>
                      {showfilterColumns && (
                        <div
                          style={{
                            position: "absolute",
                            top: "32px",
                            right: "0",
                            background: "white",
                            padding: "12px",
                            border: "1px solid whitesmoke",
                            width: "250px",
                            zIndex: 2,
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-baseline">
                            <p className="m-0 fw-600">Filter</p>
                            <Button
                              themeColor={"primary"}
                              fillMode={"flat"}
                              onClick={() => setShowFilterColumns(false)}
                            >
                              <RxCross2 />
                            </Button>
                          </div>
                          <hr className="m-1" style={{ color: "lightgray" }} />
                          <Field
                            wrapperClassName="d-flex flex-column checkBoxGroup-vertical"
                            inputClassName="checkBoxGroup-vertical-input"
                            id={"filter_columns"}
                            name={"filter_columns"}
                            marginRight={0}
                            marginBeetween={8}
                            component={FormCheckboxGroup}
                            options={columns}
                          />
                        </div>
                      )}
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      maxHeight: "calc(100vh - 334px)",
                      overflow: "scroll",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <table
                      ref={tableRef}
                      cellSpacing={1}
                      cellPadding={2}
                      className="table table-bordered w-100  report-view-table"
                      style={{
                        marginTop: 1,
                      }}
                    >
                      <thead>
                        <tr
                          className="text-center fw-600"
                          style={{ fontSize: 12 }}
                        >
                          {checkInclude("Name") && (
                            <th style={{ minWidth: 180, position: "relative" }}>
                              Client Name
                            </th>
                          )}

                          {checkInclude("MobileNo") && (
                            <th
                              style={{
                                minWidth: 110,
                              }}
                            >
                              Mobile No
                            </th>
                          )}
                          {checkInclude("EmailID") && (
                            <th
                              style={{
                                minWidth: 150,
                              }}
                            >
                              Email ID
                            </th>
                          )}
                          {checkInclude("LeadOwnerName") && (
                            <th
                              style={{
                                minWidth: 180,
                              }}
                            >
                              Lead Owner Name
                            </th>
                          )}
                          {checkInclude("CompanyName") && (
                            <th
                              style={{
                                minWidth: 150,
                              }}
                            >
                              Company
                            </th>
                          )}

                          {checkInclude("Title") && (
                            <th
                              style={{
                                minWidth: 120,
                              }}
                            >
                              Title
                            </th>
                          )}
                          {checkInclude("PhoneNo") && (
                            <th style={{ minWidth: 100 }}>Phone No</th>
                          )}

                          {checkInclude("Website") && (
                            <th style={{ minWidth: 120 }}>Website</th>
                          )}

                          {checkInclude("RefName") && (
                            <th style={{ minWidth: 120 }}>Reference</th>
                          )}

                          {checkInclude("RefMobileNo") && (
                            <th style={{ minWidth: 120 }}>Reference Mobile</th>
                          )}

                          {checkInclude("Industry") && (
                            <th style={{ minWidth: 120 }}>Industry</th>
                          )}

                          {checkInclude("NoofEmp") && (
                            <th style={{ minWidth: 120 }}>No of Employee</th>
                          )}

                          {checkInclude("AnnualRevenue") && (
                            <th style={{ minWidth: 120 }}>Annual Revenue</th>
                          )}

                          {checkInclude("CityName") && (
                            <th style={{ minWidth: 100 }}>City</th>
                          )}

                          {checkInclude("CountryName") && (
                            <th style={{ minWidth: 100 }}>Country</th>
                          )}

                          {checkInclude("StateName") && (
                            <th style={{ minWidth: 100 }}>State</th>
                          )}

                          {checkInclude("Address") && (
                            <th style={{ minWidth: 150 }}>Address</th>
                          )}

                          {checkInclude("OccupationName") && (
                            <th style={{ minWidth: 120 }}>Occupation</th>
                          )}

                          {checkInclude("BirthDate") && (
                            <th style={{ minWidth: 100 }}>Birth Date</th>
                          )}

                          {checkInclude("MarriageDate") && (
                            <th style={{ minWidth: 100 }}>Marriage Date</th>
                          )}

                          {checkInclude("PinCode") && (
                            <th style={{ minWidth: 80 }}>Pincode</th>
                          )}

                          {checkInclude("Notes") && (
                            <th style={{ minWidth: 150 }}>Notes</th>
                          )}

                          {checkInclude("GroupCode") && (
                            <th style={{ minWidth: 100 }}>Group Code</th>
                          )}

                          {checkInclude("LeadStage") && (
                            <th style={{ minWidth: 120 }}>Lead Stage</th>
                          )}

                          {checkInclude("RelationManagerName") && (
                            <th style={{ minWidth: 180 }}>Relation Manager</th>
                          )}

                          {checkInclude("BusinessType") && (
                            <th
                              data-sort="BusinessType"
                              style={{ minWidth: 350 }}
                            >
                              Business Type
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {RelationshipManagerReportList &&
                          RelationshipManagerReportList?.length > 0 &&
                          RelationshipManagerReportList?.map((client: any) => {
                            const isSelected = selectedGroup === `${client.ID}`;
                            return (
                              <tr
                                className="text-center"
                                style={{
                                  background: isSelected
                                    ? "#a3f7c587"
                                    : "transparent",
                                }}
                                onClick={() => handleRowClick(client.ID)}
                              >
                                {checkInclude("Name") && (
                                  <td className="text-start">
                                    <div
                                      className={
                                        isEditAccessLeads
                                          ? "hoverableName"
                                          : "normalName"
                                      }
                                      onClick={() => {
                                        navigate("/clientform/edit", {
                                          state: {
                                            LeadGUID: client?.LeadGUID,
                                            isReport: true,
                                            RelationManagerID:
                                              RelationshipManagerReportDetails?.RelationManagerID
                                                ? RelationshipManagerReportDetails?.RelationManagerID
                                                : null,
                                          },
                                        });
                                        isEditRef.current = true;
                                      }}
                                    >
                                      {client.Name}
                                    </div>

                                    {/* {client.Name} */}
                                  </td>
                                )}
                                {checkInclude("MobileNo") && (
                                  <td className="text-start">
                                    {client.MobileNo}
                                  </td>
                                )}

                                {checkInclude("EmailID") && (
                                  <td className="text-start">
                                    {client.EmailID}
                                  </td>
                                )}

                                {checkInclude("LeadOwnerName") && (
                                  <td className="text-start">
                                    {client.LeadOwnerName}
                                  </td>
                                )}

                                {checkInclude("CompanyName") && (
                                  <td className="text-start">
                                    {client.CompanyName}
                                  </td>
                                )}

                                {checkInclude("Title") && (
                                  <td className="text-start">{client.Title}</td>
                                )}

                                {checkInclude("PhoneNo") && (
                                  <td className="text-start">
                                    {client.PhoneNo}
                                  </td>
                                )}

                                {checkInclude("Website") && (
                                  <td className="text-start">
                                    {client.Website}
                                  </td>
                                )}

                                {checkInclude("RefName") && (
                                  <td className="text-start">
                                    {client.RefName}
                                  </td>
                                )}

                                {checkInclude("RefMobileNo") && (
                                  <td className="text-start">
                                    {client.RefMobileNo}
                                  </td>
                                )}

                                {checkInclude("Industry") && (
                                  <td className="text-start">
                                    {client.Industry}
                                  </td>
                                )}

                                {checkInclude("NoofEmp") && (
                                  <td className="text-start">
                                    {client.NoofEmp}
                                  </td>
                                )}

                                {checkInclude("AnnualRevenue") && (
                                  <td className="text-start">
                                    {client.AnnualRevenue}
                                  </td>
                                )}

                                {checkInclude("CityName") && (
                                  <td className="text-start">
                                    {client.CityName}
                                  </td>
                                )}

                                {checkInclude("CountryName") && (
                                  <td className="text-start">
                                    {client.CountryName}
                                  </td>
                                )}

                                {checkInclude("StateName") && (
                                  <td className="text-start">
                                    {client.StateName}
                                  </td>
                                )}

                                {checkInclude("Address") && (
                                  <td className="text-start">
                                    {client.Address}
                                  </td>
                                )}

                                {checkInclude("OccupationName") && (
                                  <td className="text-start">
                                    {client.OccupationName}
                                  </td>
                                )}

                                {checkInclude("BirthDate") && (
                                  <td className="text-start">
                                    {client.BirthDate}
                                  </td>
                                )}

                                {checkInclude("MarriageDate") && (
                                  <td className="text-start">
                                    {client.MarriageDate}
                                  </td>
                                )}

                                {checkInclude("PinCode") && (
                                  <td className="text-start">
                                    {client.PinCode}
                                  </td>
                                )}

                                {checkInclude("Notes") && (
                                  <td className="text-start">{client.Notes}</td>
                                )}

                                {checkInclude("GroupCode") && (
                                  <td className="text-start">
                                    {client.GroupCode}
                                  </td>
                                )}

                                {checkInclude("LeadStage") && (
                                  <td className="text-start">
                                    {client.LeadStage}
                                  </td>
                                )}

                                {checkInclude("RelationManagerName") && (
                                  <td className="text-start">
                                    {client.RelationManagerName}
                                  </td>
                                )}

                                {checkInclude("BusinessType") && (
                                  <td className="text-start">
                                    {client.BusinessType}
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};
export default RelationshipManagerReport;
